import React from 'react'

import { pluralize } from '@fourthwall/utils/dist/string'

type FulfilledOrderIDsToastProps = {
  ids: string[]
}

export const FulfilledOrderIDsToast = ({ ids }: FulfilledOrderIDsToastProps) => (
  <div>
    <p>
      Created {ids.length} fulfillment {pluralize(ids.length, 'ID')}:
    </p>
    <ol>
      {ids.map((id) => (
        <li key={id}>{id}</li>
      ))}
    </ol>
  </div>
)
